import $ from 'jquery'

const language = window.WIDGET_LANGUAGE || 'en';
const subdir = language === 'en' ? '' : '/es';

export class DataAPI {

    getAjaxData = function (url, handler) {

        $.ajax({
            url: subdir + url,
            dataType: "json",
            success: function (data) {
                handler(data)
            },
            error: function (data) {
                console.log(data)
            }
        })
    }

    fetchEnrollData = function (handler) {
        let url = "/assets/data/enroll.json"
        this.getAjaxData(url, handler)
    }

    fetchEligibleData = function (handler) {
        let url = "/assets/data/eligible.json"
        this.getAjaxData(url, handler)
    }

    fetchTranslationData = function (handler) {
        let url = "/assets/data/translation.json"
        this.getAjaxData(url, handler)
    }

    fetchDownloadData = function (handler) {
        let url = "/assets/data/download.json"
        this.getAjaxData(url, handler)
    }

    fetchContactData = function (handler) {
        let url = "/assets/data/contact.json"
        this.getAjaxData(url, handler)
    }

    fetchFPLData = function (handler) {
        let url = "/assets/data/fpl.json"
        this.getAjaxData(url, handler)
    }
}

